import {Hash} from "~/interfaces/hashInterfaces";

export enum ErrorType {
  invalidValue = 1,
  mustBePresent = 2,
  duplicateError = 3,
  mustBePublished = 4,
  brokenWorkflow = 5,
  stepRequiresStatus = 6,
  mustBeConfigured = 7,
  referenceNotFound = 8,
  multiPicklistToSingle = 9,
  dataTypeMismatchError = 10,
  readOnlyBuiltInsError = 11,
  incompatibleOwnerTypesError= 12,
  recordHolderPreserveOwnershipError = 13,
  nonexistentProperties = 15,
  invalidModelMapping = 16,
  circularReference = 17,
  invalidClearTrigger = 18,
  indexCap = 19,
  lookupKeyDestinationNotIndexed =20,
  invalidDate = 21,
  mustBeDefined = 22,

  warning = 900,
  dataTypeMismatchWarning = 901,
  recordHolderEmailWarning = 902,
  fileDimensionalTypeMismatchWarning = 903,
  presentWarning = 904,
  readOnlyLookupKeyWarning = 905,
  foundationLayerDependentsWarning = 906,
  accessibleImagesWarning = 907,

  error = 1000,
}

export const ErrorTypes = [
  ErrorType.invalidValue,
  ErrorType.mustBePresent,
  ErrorType.mustBeDefined,
  ErrorType.duplicateError,
  ErrorType.mustBePublished,
  ErrorType.brokenWorkflow,
  ErrorType.stepRequiresStatus,
  ErrorType.mustBeConfigured,
  ErrorType.referenceNotFound,
  ErrorType.multiPicklistToSingle,
  ErrorType.dataTypeMismatchError,
  ErrorType.readOnlyBuiltInsError,
  ErrorType.incompatibleOwnerTypesError,
  ErrorType.lookupKeyDestinationNotIndexed,
  ErrorType.recordHolderPreserveOwnershipError,
  ErrorType.nonexistentProperties,
  ErrorType.error,
  ErrorType.invalidModelMapping,
  ErrorType.circularReference,
  ErrorType.invalidClearTrigger,
  ErrorType.indexCap,
  ErrorType.invalidDate,
];

export const WarningTypes = [
  ErrorType.warning,
  ErrorType.dataTypeMismatchWarning,
  ErrorType.recordHolderEmailWarning,
  ErrorType.fileDimensionalTypeMismatchWarning,
  ErrorType.presentWarning,
  ErrorType.readOnlyLookupKeyWarning,
  ErrorType.foundationLayerDependentsWarning,
  ErrorType.accessibleImagesWarning,
]

export const AllValidationErrorTypes = ErrorTypes.concat(WarningTypes);

const messages: Hash = {
  [ErrorType.invalidValue]: {
    title: "Invalid Value",
  },
  [ErrorType.duplicateError]: {
    title: "Duplicate Error",
  },
  [ErrorType.mustBePublished]: {
    title: "Must be Published",
  },
  [ErrorType.brokenWorkflow]: {
    title: "Broken Workflow",
  },
  [ErrorType.stepRequiresStatus]: {
    title: "Step Requires Status",
  },
  [ErrorType.mustBeConfigured]: {
    title: "Must be Configured",
  },
  [ErrorType.referenceNotFound]: {
    title: "Reference not found",
  },
  [ErrorType.circularReference]: {
    title: "Circular Reference"
  },
  [ErrorType.multiPicklistToSingle]: {
    title: "Multi-picklist maps to a single picklist",
  },
  [ErrorType.dataTypeMismatchError]: {
    title: "Non-Matching Data Types Error",
  },
  [ErrorType.readOnlyBuiltInsError]: {
    title: "Mapping cannot push to Read-Only field",
  },
  [ErrorType.readOnlyLookupKeyWarning]: {
    title: "Mapping cannot push to Read-Only field",
  },
  [ErrorType.incompatibleOwnerTypesError]: {
    title: 'Incompatible Record Holder Type',
  },
  [ErrorType.lookupKeyDestinationNotIndexed]:{
    title: "Destination Key Not Indexed"
  },
  [ErrorType.recordHolderPreserveOwnershipError]: {
    title: 'Record Holder Email and Preserve Ownership Option Incompatible',
  },
  [ErrorType.nonexistentProperties]: {
    title: 'Properties No Longer Exist',
  },
  [ErrorType.invalidClearTrigger]: {
    title: 'Invalid Trigger',
  },
  [ErrorType.indexCap]: {
    title: 'Indexed Property Limit'
  },

  [ErrorType.warning]: {
    title: "Warning",
  },
  [ErrorType.dataTypeMismatchWarning]: {
    title: "Non-Matching Data Types Warning",
    description: `<p>The following value mappings do not have compatible data-types. Please update to ensure your mapping will not fail.
          </p>
          <p>
          <small>
          <strong>
          * You will still be able to publish without fixing the data types. However, your mapping might have errors while running or fail to execute.
          </strong>
          </small>
          </p>
          `,
  },
  [ErrorType.recordHolderEmailWarning]: {
    title: "Record Holder Override -- Mapping to the Record Holder Email value will initiate the claim process for the user at the new email address. When a mapping updates this field, the old user will no longer have access to the record, and the new user will be sent an email to claim it for themselves or an entity if the object model is configured to display on a user/entity dashboard.",
  },
  [ErrorType.fileDimensionalTypeMismatchWarning]: {
    title: "File Attachment selected can only store one file",
  },
  [ErrorType.presentWarning]: {
    title: "Blank Label Warning",
  },
  [ErrorType.invalidModelMapping]: {
    title: "Invalid Model Mapping"
  },
  [ErrorType.mustBeDefined]: {
    title: "Must be Defined"
  },
  [ErrorType.foundationLayerDependentsWarning]: {
    title: "Warning",
    description: `<p>The following documents use the document you are publishing as a Foundation Layer. Are you sure you want to publish these changes?</p>`,
  },
  [ErrorType.accessibleImagesWarning]: {
    title: 'Image Accessibility Warning',
    description: `<p>Images on this form are missing alternative text and/or image captions. It is recommended to add these items to meet accessibility standards.</p>
                  <p>Add an image caption / alt text by clicking on the image.</p>`,
  },
};
const defaultMessage = {
  title: "Must be Present"
};

export function getMessage(errorType): string {
  return messages[parseInt(errorType, 10)] || defaultMessage
}